import { render, staticRenderFns } from "./MarksheetICSE.vue?vue&type=template&id=7bde9c5d&scoped=true&"
import script from "./MarksheetICSE.vue?vue&type=script&lang=js&"
export * from "./MarksheetICSE.vue?vue&type=script&lang=js&"
import style0 from "./MarksheetICSE.vue?vue&type=style&index=0&id=7bde9c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bde9c5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VRow,VSnackbar})
